import Modal from "react-modal";
import {X} from "react-feather";
import React, {useState} from "react";
import {useFormik} from "formik";
import * as Yup from "yup";
import TextInput from "../../Formik/TextInput";
import {ADMIN} from "../../../services/constants/VendorAccountPrivilegues";
import {checkAccountEmail} from "../../../services/api/vendor";
import {Alert} from "flowbite-react";
import {InfoCircle} from "flowbite-react-icons/outline";

const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const CreateUserModal = ({onClose, onUserCreated, type}) => {
    const [emailValidated, setEmailValidated] = useState(false);

    const formik = useFormik({
        initialValues: {
            first_name: null,
            last_name: null,
            email: null,
            role: ADMIN,
        },
        validationSchema: Yup.object().shape({
            first_name: Yup.string().required('First name is required').max(50, 'Max 50 characters'),
            last_name: Yup.string().required('Last name is required').max(50, 'Max 50 characters'),
            email: Yup.string().required('Email is required').matches(emailRegex, 'Invalid email format'),
            role: Yup.string().required('Role is required'),
        }),
        onSubmit: async (values) => {
            try {
                setEmailValidated(false)
                const res = await checkAccountEmail(values.email);
                if (!res.available) {
                    setEmailValidated('This email is already taken');
                    return
                }

                await onUserCreated(values, type);
                onClose();
            } catch (e) {
                console.error(e)
            }
        },
    });


    return (
        <Modal
            isOpen={true}
            className="sl-modal-content sl-max-modal"
            overlayClassName="sl-modal sl-block sl-rounded-md sl-bg-gray-900-opacity-50">

            <div className="sl-modal-body">
                <div
                    className="sl-modal-header sl-rounded-md sl-flex sl-justify-between sl-bg-gray-50 sl-text-gray-900 sl-px-6 sl-py-16 sl-border-bottom">
                    <div
                        className="title sl-font-semibold sl-text-lg sl-mr-auto sl-ml-0 sl-font">
                        Create new user

                    </div>
                    <div className="sl-cursor-pointer sl-btn-link-gray sl-mr-0">
                        <X onClick={onClose}/>
                    </div>
                </div>
                <div className="sl-modal-body">
                </div>
            </div>
            <div className="sl-modal-body">
                <div
                    className="sl-modal-body sl-max-h-185i sl-h-auto sl-px-6 sl-pb-0 sl-pt-24"
                >


                    <div className={"sl-flex-col sl-flex sl-gap-6 "}>
                        <TextInput formik={formik} label={'First name'} name={'first_name'}/>
                        <TextInput formik={formik} label={'Last name'} name={'last_name'}/>
                        <TextInput formik={formik} label={'Email'} name={'email'} error={emailValidated}
                                   inputChange={() => setEmailValidated(false)}/>
                        <Alert color="light"
                               className={"sl-bg-gray-25 sl-border-gray-300 border-solid sl-border sl-w-full sl-flex sl-flex-row "}
                               icon={InfoCircle}>
                            <div className={"sl-flex sl-flex-col sl-gap-1"}>

                                <span
                                    className={"sl-text-gray-700 sl-text-sm sl-font-medium sl-font"}>Invite new user</span>
                                <span className={"sl-text-gray-600 sl-text-sm sl-font-regular sl-font"}>Once you submit, an email invitation will be sent to the new user to claim their account.
                                Make sure to notify them to expect the email with setup instructions.</span>
                            </div>
                        </Alert>
                    </div>
                </div>
            </div>


            <div className="sl-modal-footer sl-px-6 sl-py-32  sl-display-flex sl-flex-row sl-justify-space-between">

                <div
                    className="sl-flex sl-justify-end sl-gap-2-point-5
                             sl-bg-white sl-rounded-bottom-left-xl sl-rounded-bottom-right-xl sl-mt-0i sl-font sl-text-md sl-font-normal">
                    <button
                        onClick={onClose}
                        className="sl-btn sl-btn-tertiary sl-btn-lg  sl-rounded-lg sl-text-md sl-pl-20 sl-pr-20 sl-font">
                        Cancel
                    </button>
                </div>

                <div
                    className="sl-flex sl-justify-end sl-gap-2-point-5 sl-bg-white sl-rounded-bottom-left-xl sl-rounded-bottom-right-xl sl-mt-0i sl-font sl-text-md sl-font-normal">
                    <button
                        onClick={() => formik.handleSubmit()}
                        className="sl-btn sl-btn-primary sl-btn-lg  sl-rounded-lg sl-text-md sl-pl-20 sl-pr-20 sl-font ">
                        Done
                    </button>
                </div>

            </div>
        </Modal>
    );

}

export default CreateUserModal;